import { List } from "@mui/material";

import { CaseNoteResponse } from "@/api";

import { CaseNoteListItem } from "./components/case-note-list-item/CaseNoteListItem";

interface Props {
  caseNotes: CaseNoteResponse[] | undefined;
  selectedCaseNote: CaseNoteResponse | null;
  onSelect: (selectedNote: CaseNoteResponse) => void;
}

export function CaseNotesList({ caseNotes, selectedCaseNote, onSelect }: Props) {
  return (
    <List disablePadding sx={{ overflowY: "auto", overflowX: "hidden", flex: 1 }}>
      {caseNotes?.map((caseNote) => {
        return (
          <CaseNoteListItem
            key={caseNote.caseNoteId}
            caseNote={caseNote}
            selected={caseNote.caseNoteId === selectedCaseNote?.caseNoteId}
            onSelect={onSelect}
          />
        );
      })}
    </List>
  );
}
